"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = require("react");
var _base = require("@mui/base");
var _Button = require("@mui/base/Button");
var _classVarianceAuthority = require("class-variance-authority");
var _helpers = require("../../common/helpers");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["color", "variant", "size", "shape", "width", "loading", "startDecorator", "endDecorator", "as", "className", "label", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var classes = (0, _classVarianceAuthority.cva)(['flex', 'items-center', 'justify-center', 'text-center', 'gap-2', 'font-sans', 'font-semibold', 'relative', 'box-border', 'outline-none', 'before:outline-offset-2', 'before:outline-2', 'before:focus-visible:outline', 'appearance-none', 'before:transition', 'before:duration-200', 'before:absolute', 'before:inset-0', 'before:z-[-1]', 'z-[1]', 'before:rounded-full', 'transition-colors', 'select-none'], {
  variants: {
    variant: {
      filled: [],
      outlined: ['before:border'],
      flat: []
    },
    color: {
      primary: ['before:outline-primary'],
      light: ['before:outline-white'],
      transparent: ['before:bg-transparent', 'before:outline-primary']
    },
    size: {
      xs: ['h-8', 'min-w-[2rem]', 'text-sm', 'leading-none'],
      sm: ['h-10', 'min-w-[2.5rem]', 'text-sm', 'leading-tight'],
      md: ['h-[3.75rem]', 'min-w-[3.75rem]', 'text-normal', 'leading-snug']
    },
    width: {
      auto: [],
      sm: [],
      md: [],
      lg: [],
      full: []
    },
    shape: {
      rounded: [],
      circle: []
    },
    disabled: {
      "true": ['cursor-not-allowed', 'opacity-20'],
      "false": ['cursor-pointer']
    },
    loading: {
      "true": [],
      "false": []
    }
  },
  compoundVariants: [
  // Color
  {
    variant: 'filled',
    color: 'primary',
    className: ['before:bg-primary', 'text-white']
  }, {
    variant: 'filled',
    color: 'light',
    className: ['before:bg-white', 'text-gray-700']
  }, {
    variant: 'filled',
    color: 'transparent',
    className: ['text-gray-700']
  }, {
    variant: 'outlined',
    color: 'primary',
    className: ['before:bg-white', 'before:border-primary', 'text-primary']
  }, {
    variant: 'outlined',
    color: 'light',
    className: ['before:bg-transparent', 'before:border-white', 'text-white']
  }, {
    variant: 'outlined',
    color: 'transparent',
    className: ['before:border-gray-200', 'text-gray-700']
  },
  // Size
  {
    size: 'xs',
    shape: 'rounded',
    className: ['px-4']
  }, {
    size: 'sm',
    shape: 'rounded',
    className: ['px-5']
  }, {
    size: 'md',
    shape: 'rounded',
    className: ['px-6']
  }, {
    size: 'xs',
    shape: 'circle',
    className: ['w-8']
  }, {
    size: 'sm',
    shape: 'circle',
    className: ['w-10']
  }, {
    size: 'md',
    shape: 'circle',
    className: ['w-[3.75rem]']
  },
  // Width
  {
    width: 'auto',
    shape: 'rounded',
    className: ['w-fit']
  }, {
    width: 'sm',
    shape: 'rounded',
    className: ['w-full', 'sm:w-[140px]']
  }, {
    width: 'md',
    shape: 'rounded',
    className: ['w-full', 'sm:w-[200px]']
  }, {
    width: 'lg',
    shape: 'rounded',
    className: ['w-full', 'sm:w-[310px]']
  }, {
    width: 'full',
    shape: 'rounded',
    className: ['w-full']
  },
  // Animation
  {
    variant: ['filled', 'outlined'],
    color: ['primary', 'light'],
    shape: 'rounded',
    disabled: false,
    className: ['before:hover:scale-x-[1.015]', 'before:hover:scale-y-[1.035]']
  }, {
    variant: ['filled', 'outlined'],
    color: ['primary', 'light'],
    shape: 'circle',
    disabled: false,
    className: ['before:hover:scale-[1.035]']
  }, {
    variant: ['filled', 'outlined'],
    color: ['primary', 'light'],
    disabled: false,
    className: ['before:hover:drop-shadow', 'before:ease-in-out']
  }, {
    variant: 'outlined',
    color: 'transparent',
    disabled: false,
    className: ['before:hover:drop-shadow', 'before:ease-in-out']
  }, {
    variant: 'filled',
    color: 'transparent',
    disabled: false,
    className: ['before:ease-bounce-in', 'before:scale-75', 'before:hover:scale-100', 'before:hover:bg-black', 'before:hover:bg-opacity-[0.07]']
  }, {
    variant: 'filled',
    color: 'primary',
    disabled: false,
    className: ['before:hover:bg-primary-800']
  }, {
    variant: 'filled',
    color: 'light',
    disabled: false,
    className: ['before:hover:bg-gray-100']
  }, {
    variant: 'outlined',
    color: 'primary',
    disabled: false,
    className: ['before:hover:bg-primary-50']
  }, {
    variant: 'outlined',
    color: 'light',
    disabled: false,
    className: ['before:hover:bg-white/20']
  }, {
    variant: 'outlined',
    color: 'transparent',
    disabled: false,
    className: ['before:hover:bg-white/20']
  }]
});
var configureDecorator = function configureDecorator(decorator) {
  return /*#__PURE__*/(0, _react.cloneElement)(decorator, {
    color: 'white'
  });
};

/**
 * Button - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/inputs-button) | [DSM](https://sharphealthcare.notion.site/Buttons-578bdc350e5e411fbd1d3c9b12597ac4)
 */
var Button = exports.Button = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'filled' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'rounded' : _ref$shape,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'lg' : _ref$width,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    startDecorator = _ref.startDecorator,
    endDecorator = _ref.endDecorator,
    as = _ref.as,
    className = _ref.className,
    label = _ref.label,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.ClassNameConfigurator, {
    disableDefaultClasses: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.Button, _objectSpread(_objectSpread({}, props), {}, {
      role: "button",
      ref: ref,
      slots: as && {
        root: (0, _base.prepareForSlot)(as)
      },
      slotProps: {
        root: function root(buttonState) {
          return {
            className: (0, _helpers.cn)(classes({
              variant: variant,
              color: color,
              size: size,
              width: width,
              shape: shape,
              disabled: Boolean(buttonState.disabled),
              loading: loading,
              className: className
            }))
          };
        }
      },
      children: [startDecorator && configureDecorator(startDecorator), label !== null && label !== void 0 ? label : children, endDecorator && configureDecorator(endDecorator)]
    }))
  });
});